// @Version: 1.0.1
import { Injectable } from '@angular/core';
import { ErrorMessagesService } from '../../../services/errorMessages/error-messages.service';
import { IErrorCodes } from '../../../services/errorMessages/error-messages.model';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TRANSLATE_PATH } from 'src/app/shared/shared.model';

interface IRadioButton {
  value: string,
  label: string
}

UntilDestroy()
@Injectable()
export class FieldItemRadioService {

   private required_: boolean = false;
   private radioButtons_: IRadioButton[] = [];
   private errorCodes_: IErrorCodes = {} as IErrorCodes;

   get required (): boolean {
      return this.required_;
   }
   set required (value: boolean) {
      this.required_ = value;
   }

   get radioButtons (): IRadioButton[] {
      return this.radioButtons_;
   }

   get errorCodes (): IErrorCodes {
      return this.errorCodes_;
   }

   constructor (private sErrorMessage: ErrorMessagesService) {}

   public reset (): void {
      this.required_ = false;
      this.radioButtons_ = [];
      this.errorCodes_ = {} as IErrorCodes;
   }

   public createErrorMessages (errorMessage: string): boolean {
      this.errorCodes_ = this.sErrorMessage.setErrorCodes(errorMessage, TRANSLATE_PATH.FIELD_ITEM_ERROR);
      return true;
   }

   public createRadioButtons (attribute: string): boolean {
      let splitAttribute1 = attribute.split(';');
      splitAttribute1.forEach((elem) => {
         this.radioButtons_.push({
            label: elem.split(":")[1],
            value: elem.split(":")[0]
         })
      });

      return true;
   }
}